// Homepage header: a light frosted tint over the hero at the top of the page, deepening once the
// page scrolls. Driven by scroll position only so phones, tablets and desktop behave the same;
// keyboard focus inside the header also deepens it so focused links stay legible.
const header = document.querySelector('[data-header-overlay]');

if (header) {
  let frame = 0;

  const render = () => {
    frame = 0;
    const scrolled = window.scrollY > 8;
    const keyboardFocus = header.querySelector(':focus-visible') !== null;
    header.toggleAttribute('data-transparent', !scrolled && !keyboardFocus);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(render);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  header.addEventListener('focusin', schedule);
  header.addEventListener('focusout', () => setTimeout(schedule));
  render();
}
